<template>
  <el-dialog
    :modal-append-to-body="false"
    :visible.sync="visible"
    :title="$t('Integrations_Kochava_SyncDialog_Title')"
    width="400px"
    center
  >
    <rest-form
      :model="taskModel"
      :save-endpoint="saveEndpoint"
      :success-message="$t('Integrations_Kochava_SyncDialog_SuccessMessage')"
      :rules="rules"
      ref="form"
    >
      <el-row type="flex" justify="center">
        <rest-form-item prop="daterange">
          <el-date-picker
            v-model="taskModel.daterange"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            :default-time="['00:00:00', '23:59:59']"
          />
        </rest-form-item>
      </el-row>

      <el-row type="flex" justify="center">
        <el-button type="primary" @click="save">
          {{ $t('Integrations_Kochava_SyncDialog_StartSync') }}
        </el-button>
      </el-row>
    </rest-form>
  </el-dialog>
</template>

<script>
import RestForm from '@/common/components/rest/RestForm'
import RestFormItem from '@/common/components/rest/RestFormItem'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'KochavaSyncDialog',

  components: { RestForm, RestFormItem },

  data() {
    return {
      taskModel: {},
      visible: false
    }
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  computed: {
    saveEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `integrations/kochava/${this.model.id}/sync-installs`
      })
    },

    rules() {
      return {
        daterange: {
          required: true
        }
      }
    }
  },

  methods: {
    show() {
      this.visible = true
    },

    save() {
      this.$refs['form'].save().then(taskRecord => {
        this.$router.push(
          projectRoute({
            name: 'TaskHistoryView',
            query: { id: taskRecord.id }
          })
        )
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/kochava/KochavaSyncDialog.vue